import {useContracts as useContractsQuery} from '@chekin/shared/guest-form';
import {useReservation} from 'context/reservation';
import {useSummary} from 'context/summary';

function useContracts() {
  const {housing} = useReservation();
  const {data: summary} = useSummary();

  return useContractsQuery({
    housingId: housing?.id,
    isContractEnabled: summary?.is_contract_enabled,
  });
}

export {useContracts};
